import React, {useState} from "react";
import styles from "./ReservationsPopup.module.scss";
import moment from "moment";
import {useTranslation} from "react-i18next";
import {IClassEventReservation} from "../../../../../models/ClassEventReservation";

interface IReservationPopupProps {
    reservations: IClassEventReservation[],
    setShowDescriptionReservation: (value: {isOpen: boolean, reservation: IClassEventReservation | null}) => void,
    isCurrent: boolean
}

const ReservationsPopup: React.FC<IReservationPopupProps> = ({reservations, setShowDescriptionReservation, isCurrent}) => {

    const [isPopupOpen, setIsPopupOpen] = useState(false)
    const {t} = useTranslation();

    const handlePopup = () => {
        setIsPopupOpen(prev => !prev);
    }

    const getNaming = (reservation: IClassEventReservation) => {
        if (reservation.type === "class-event" && reservation.waitingList?.length) {
            return "WaitingList";
        } else if (reservation.type === "class-event") {
            return "Booked";
        } else if (reservation.type === "reservation") {
            return "Appointment";
        } else {
            return "";
        }
    }

    const showBookingCalendarPopup = (reservation: IClassEventReservation) => {
        setShowDescriptionReservation({isOpen: true, reservation: reservation})
    }

    return (
        <>
            <div className={styles.wrapper}>
                <button
                    onClick={handlePopup}
                    className={`${styles.btn} ${isCurrent ? styles.current : ''}`}
                >
                    {t("View")}
                </button>
            </div>
            {
                isPopupOpen && (
                    <div className={styles.popup}>
                        <div className={styles.content}>
                            <ul className={styles.list}>
                                {reservations.map(el => {
                                    return (
                                        <li key={el.id} className={`${styles.item} ${styles[getNaming(el)]}`}>
                                            <p className={styles.date}>
                                                {moment(el.occuranceDate).format("dddd")}
                                                <span>{moment(el.occuranceDate).format("DD MMMM")}</span>
                                            </p>
                                            <h4 className={styles.title}>{t(`${getNaming(el)}`)}</h4>
                                            <p className={styles.naming}>{el.trainningCourseName}</p>
                                            <p className={styles.instructor}>{el.instructorFirstName} {el.instructorLastName}</p>
                                            <p className={styles.time}>{moment(el.occuranceDate).format("hh:mm A")} - {moment(el.occuranceDate).add(el.duration, "minutes").format("hh:mm A")}</p>
                                            <span className={styles.seeDetails} onClick={() => showBookingCalendarPopup(el)}>
                                                {t("SeeDetails")}
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12.0254 4.94165L17.0837 9.99998L12.0254 15.0583" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M2.91699 10H16.942" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </span>
                                        </li>
                                    )
                                })}
                            </ul>
                            <div className={styles.wrapper}>
                                <button
                                    className={styles.cancel}
                                    onClick={handlePopup}
                                >
                                    {t("Cancel")}
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    )
}

export default ReservationsPopup;